module.exports = __webpack_public_path__ + "static/img/bg-blue.091e641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-blue.jpg
// module id = SwjX
// module chunks = 1